/**
 * Status Methods
 * API methods for getting training status, results, and evaluations
 */

import { makeRequest, getApiBaseUrl } from '../core';
import { TrainingApiResponse } from '../types';

/**
 * Get training status
 */
export async function getTrainingStatus(sessionId: string): Promise<TrainingApiResponse> {
  return makeRequest(`${getApiBaseUrl()}/get-training-status/${sessionId}`);
}

/**
 * Get pipeline overview
 */
export async function getPipelineOverview(sessionId: string): Promise<TrainingApiResponse> {
  return makeRequest(`${getApiBaseUrl()}/pipeline-overview/${sessionId}`);
}

/**
 * Get training results
 */
export async function getTrainingResults(sessionId: string): Promise<TrainingApiResponse> {
  return makeRequest(`${getApiBaseUrl()}/results/${sessionId}`);
}

/**
 * Get comprehensive evaluation
 */
export async function getComprehensiveEvaluation(sessionId: string): Promise<TrainingApiResponse> {
  return makeRequest(`${getApiBaseUrl()}/comprehensive-evaluation/${sessionId}`);
}

/**
 * Get visualizations
 */
export async function getVisualizations(sessionId: string): Promise<TrainingApiResponse> {
  return makeRequest(`${getApiBaseUrl()}/visualizations/${sessionId}`);
}
